import React, { useEffect } from "react";

const ChatWidget = () => {
  useEffect(() => {
    if (
      !document.querySelector(
        'script[src="https://cdn.commoninja.com/sdk/latest/commonninja.js"]',
      )
    ) {
      const script = document.createElement("script");
      script.src = "https://cdn.commoninja.com/sdk/latest/commonninja.js";
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="chatbot-wrapper">
      <div className="commonninja_component pid-c73d8823-604f-45b6-997a-97e435156b67"></div>
    </div>
  );
};

export default ChatWidget;
